window.printInfoAggGestite = function (){
	let infos = '';
	for(let i = 1; i <= 70; i++){
		const hand = splitHandicap(197121, i, [], null, 'IT', null);
		if(hand?.infoCalcolate > 0){
			infos += 'INFO ' + i + " GESTITA\n";
		}
	}
	console.log("INFO AGGIUNTIVE GESTITE");
	console.log(infos);
}

window.longContainedByInt = function(l){
	return l < Number.MAX_SAFE_INTEGER && l > Number.MIN_SAFE_INTEGER;
}

export function splitHandicap(handicap, handicapType, draws, additionalData, language, handicapInfo = null) {
	const handicapTradotto = {
        info1: null,
        info2: null,
        info3: null,
        info4: null,
        info5: null,
        info6: null,
        info7: null,
        info8: null,
        infoCalcolate:0
	};

    
    if (handicapInfo?.info_valide != null) {
        handicapTradotto.info1 = handicapInfo.info1;
        handicapTradotto.info2 = handicapInfo.info2;
        handicapTradotto.info3 = handicapInfo.info3;
        handicapTradotto.info4 = handicapInfo.info4;
        handicapTradotto.info5 = handicapInfo.info5;
        handicapTradotto.info6 = handicapInfo.info6;
        handicapTradotto.info7 = handicapInfo.info7;
        handicapTradotto.info8 = handicapInfo.info8;
        handicapTradotto.infoCalcolate = handicapInfo.info_valide;
    } else {
        /* splitto l'handicap */
        if (handicapType === 1 || 
            handicapType === 2 || 
            handicapType === 3 ||
            handicapType === 4 || 
            handicapType === 5 ||
            handicapType === 21 ||
            handicapType === 22) {
            handicapTradotto.info1 = handicap;
            handicapTradotto.infoCalcolate = 1;
        } else {
        	
            const buffer = new ArrayBuffer(4);
            const view = new DataView(buffer);
	        view.setInt32(0, handicap);            

            
            if (handicapType === 6  || 
                handicapType === 23 || 
                handicapType === 24 || 
                handicapType === 25 || 
                handicapType === 26 ||
                handicapType === 27 || 
                handicapType === 32 || 
                handicapType === 33 ||
                handicapType === 46) {
    
                const pos12 = view.getInt16(0);
                const pos34 = view.getInt16(2);
    
                handicapTradotto.info1 = pos34;
                handicapTradotto.info2 = pos12;
                handicapTradotto.infoCalcolate = 2;
            } else if (handicapType === 20) {
                const pos2 = view.getUint8(1);
                const pos3 = view.getUint8(2);
                const pos4 = view.getUint8(3);
    
                handicapTradotto.info1 = pos4;
                handicapTradotto.info2 = pos3;
                handicapTradotto.info3 = pos2;
                handicapTradotto.infoCalcolate = 3;
            } else if (handicapType === 7  ||  
                        handicapType === 31 || 
                        handicapType === 35 || 
                        handicapType === 38 ||
                        handicapType === 50 ||
                        handicapType === 52 ||
                        handicapType === 55) {
                const pos12 = view.getInt16(0);
                const pos3 = view.getUint8(2);
                const pos4 = view.getUint8(3);
                
                handicapTradotto.info1 = pos4;
                handicapTradotto.info2 = pos3;
                handicapTradotto.info3 = pos12;
                handicapTradotto.infoCalcolate = 3;
            } else if (handicapType === 28 || handicapType === 36 || handicapType === 70) {
                const pos1 = view.getUint8(0);
                const pos2 = view.getUint8(1);
                const pos34 = view.getInt16(2);
    
                handicapTradotto.info1 = pos34;
                handicapTradotto.info2 = pos2;
                handicapTradotto.info3 = pos1;
                handicapTradotto.infoCalcolate = 3;
            } else if (handicapType === 29) {
                const pos1 = view.getUint8(0);
                const pos23 = view.getInt16(1);
                const pos4 = view.getUint8(3);
    
                handicapTradotto.info1 = pos4;
                handicapTradotto.info2 = pos23;
                handicapTradotto.info3 = pos1;
                handicapTradotto.infoCalcolate = 3;
            } else if (handicapType === 30 ||
            		   handicapType === 34 || 
            		   handicapType === 37 || 
            		   handicapType === 40 || 
            		   handicapType === 42 || 
            		   handicapType === 44 ||
            		   handicapType === 47 ||
            		   handicapType === 49 ||
            		   handicapType === 53 ||
            		   handicapType === 56 ||
            		   handicapType === 66) {
                const pos1 = view.getUint8(0);
                const pos2 = view.getUint8(1);
                const pos3 = view.getUint8(2);
                const pos4 = view.getUint8(3);
                
                handicapTradotto.info1 = pos4;
                handicapTradotto.info2 = pos3;
                handicapTradotto.info3 = pos2;
                handicapTradotto.info4 = pos1;
                handicapTradotto.infoCalcolate = 4;
            } else if (handicapType === 48){
                const pos3 = view.getUint8(3);
                //handicapTradotto.info1 = pos3;
                //handicapTradotto.info2 = pos2;
                //handicapTradotto.info3 = pos1;
                handicapTradotto.info1 = pos3;
                handicapTradotto.infoCalcolate = 1;
            } else if(handicapType === 64){
				if(window.longContainedByInt(handicap)){
	            	try {
		            	const pos1 = view.getInt16(0);
		                const pos2 = view.getInt16(2);
		                const pos3 = view.getInt16(4);
		                const pos4 = view.getInt16(8);
		                handicapTradotto.info1 = pos4;
		                handicapTradotto.info2 = pos3;
		                handicapTradotto.info3 = pos2;
		                handicapTradotto.info4 = pos1;
		                handicapTradotto.infoCalcolate = 4;		
	            	} catch(e){
	            		console.debug("SPLIT INFO 64 failed")
	            	}
		
				}
				else if(handicapInfo){
					handicapTradotto.info1 = handicapInfo.info1;
					handicapTradotto.info2 = handicapInfo.info2;
					handicapTradotto.info3 = handicapInfo.info3;
					handicapTradotto.info4 = handicapInfo.info4;
					handicapTradotto.info5 = handicapInfo.info5;
					handicapTradotto.info6 = handicapInfo.info6;
					handicapTradotto.info7 = handicapInfo.info7;
					handicapTradotto.info8 = handicapInfo.info8;
					handicapTradotto.infoCalcolate = handicapInfo.info_valide;	
				}

            }
        }
    }
	
	// traduco l'handicap in base alla tipologia
	if (handicapType === 1 || handicapType === 2 || handicapType === 3 || handicapType === 4) {
			handicapTradotto.info1 = `${handicap / 100}`;
			handicapTradotto.infoCalcolate = 1;
	} else if (handicapType === 5 || handicapType === 6) {
		handicapTradotto.idAnagrafica = handicapTradotto.info1;
		let descrizioneInfoAggiuntiva = handicap;
		if (additionalData?.length > 0) {
			descrizioneInfoAggiuntiva = additionalData;
		}
		handicapTradotto.info1 = descrizioneInfoAggiuntiva;
		handicapTradotto.infoCalcolate = 1;
	} else if (handicapType === 7) {
		handicapTradotto.idAnagrafica = handicapTradotto.info1;
		handicapTradotto.idAnagrafica2 = handicapTradotto.info2;
		handicapTradotto.infoCalcolate = 2;			
		let dia = null;
		if (additionalData?.length > 0) {
			dia = additionalData;
		}
		
		if (dia) {
			let splittingChar = '';
			if(additionalData.indexOf('$') > 0){
				splittingChar = '$';
			}
			else if(additionalData.indexOf(' - ') > 0){
				splittingChar = ' - ';
			}
			// print case or market not in (head to head, 1x2) types
			if(dia.indexOf(splittingChar) > 0){
				handicapTradotto.info1 = dia.split(splittingChar)[0];
				handicapTradotto.info2 = dia.split(splittingChar)[1];
				handicapTradotto.info3 = null;
				handicapTradotto.info4 = null;
			}
			else{
				handicapTradotto.info1 = dia;
				handicapTradotto.info2 = "";
			}
		} else if (draws != null) {
			for (let i = 0; i < draws.length; i++) {
				let descDraw = '';
				let draw = draws[i];
				if (draw.dsl) {
					descDraw += draw.dsl[language];					
				} else if (draw.d) {
					descDraw += draw.d;
				} else if(draw.desc){
					descDraw += draw.desc;
				}
				if(i === 0){
					handicapTradotto.info1 = descDraw;
				}
				else {
					if(i === 1) {
						handicapTradotto.info2 = descDraw;
					}
					else {
						handicapTradotto.info2 = handicapTradotto.info2 + " - " + descDraw;
					}
				}
			}
			if(draws.length === 1){
				handicapTradotto.info2 = "";
			}
		}
	} else if (handicapType === 26) {
		handicapTradotto.info1 = `${handicapTradotto.info1 / 10}`;
		handicapTradotto.info2 = `${handicapTradotto.info2 / 10}`;
	} else if (handicapType === 23 || 
			   handicapType === 28 || 
			   handicapType === 29 || 
			   handicapType === 30 || 
			   handicapType === 33) {
		handicapTradotto.info1 = `${handicapTradotto.info1 / 10}`;
	} else if (handicapType === 35 || handicapType === 38) {
		let h1 = handicapTradotto.info3;
		let h2 = "Player " + handicapTradotto.info1;
		handicapTradotto.idAnagrafica = handicapTradotto.info1;
		if (handicapType === 35) {			
			h1 = `${h1 / 10}`;
		}
		if (additionalData != null) {
			h2 = additionalData;
		}
		handicapTradotto.info1 = h2;
		handicapTradotto.info2 = h1;
		handicapTradotto.infoCalcolate = 2;
	}
	else if(handicapType === 37 || handicapType === 34){
		handicapTradotto.idAnagrafica = handicapTradotto.info1;
		handicapTradotto.idAnagrafica2 = handicapTradotto.info2;
		if(additionalData){
			let splittingChar = '';
			if(additionalData.indexOf('$') > 0){
				splittingChar = '$';
			}
			else if(additionalData.indexOf(' - ') > 0){
				splittingChar = ' - ';
			}
			if(splittingChar){
				handicapTradotto.info1 = additionalData.split(splittingChar)[0];
				handicapTradotto.info2 = additionalData.split(splittingChar)[1];				
			}
			else {
				handicapTradotto.info1 = additionalData;
				handicapTradotto.info2 = '';				
			}
	
		}
		if(handicapType === 34){
			handicapTradotto.info4 = `${handicapTradotto.info4 / 10}`;
		}
	} 
	
	else if(handicapType === 44){
		let dia = null;
		if (additionalData?.length > 0) {
			dia = additionalData;
		}
		handicapTradotto.idAnagrafica = handicapTradotto.info1;
		if (dia) {	
			handicapTradotto.info1 = dia;
		}
		handicapTradotto.info2 = handicapTradotto.info3 + "°"; // game period
		
		handicapTradotto.info3 = handicapTradotto.info4 / 10;
		handicapTradotto.info4 = null;
		handicapTradotto.infoCalcolate = 3;
	
	} 
	else if (handicapType === 46 && additionalData) {
		handicapTradotto.info2 = additionalData;
	} else if((handicapType === 47 || handicapType === 48) && additionalData?.length > 0) {
		handicapTradotto.idAnagrafica = handicapTradotto.info1;
		handicapTradotto.info1 = additionalData;
	} else if(handicapType === 49 || handicapType === 52){
		handicapTradotto.info1 = handicapTradotto.info1 / 10;
		handicapTradotto.info2 = handicapTradotto.info2 / 10;	
	} else if (handicapType === 53){
		handicapTradotto.idAnagrafica = handicapTradotto.info1;
		handicapTradotto.idAnagrafica2 = handicapTradotto.info2;
		handicapTradotto.idAnagrafica3 = handicapTradotto.info3;
		handicapTradotto.infoCalcolate = 3;
		if(additionalData){
			let splittingChar = '';
			if(additionalData.indexOf('$') > 0){
				splittingChar = '$';
			}
			else if(additionalData.indexOf(' - ') > 0){
				splittingChar = ' - ';
			}
			const values = additionalData.split(splittingChar);
			handicapTradotto.info1 = values[0];
			handicapTradotto.info2 = values[1];
			handicapTradotto.info3 = values[2];
		}
	} else if(handicapType === 54) {
		handicapTradotto.idAnagrafica = handicapTradotto.info1;
		handicapTradotto.idAnagrafica2 = handicapTradotto.info3;
		if(additionalData){
			let splittingChar = '';
			if(additionalData.indexOf('$') > 0){
				splittingChar = '$';
			}
			else if(additionalData.indexOf(' - ') > 0){
				splittingChar = ' - ';
			}
			const values = additionalData.split(splittingChar);
			handicapTradotto.info1 = values[0];
			handicapTradotto.info3 = values[1];
		}
	} else if(handicapType === 56){
		let dia = null;
		if (additionalData?.length > 0) {
			dia = additionalData;
		}
		handicapTradotto.idAnagrafica = handicapTradotto.info1;
		if (dia) {	
			handicapTradotto.info1 = dia;
		}
	
	} else if(handicapType == 57){
		handicapTradotto.info1 = additionalData || handicapTradotto.info1;
		handicapTradotto.info5 = `${handicapTradotto.info5 / 10}`;
	} else if(handicapType == 58){
		handicapTradotto.info1 = `${handicapTradotto.info1 / 100}`;
		handicapTradotto.info2 = `${handicapTradotto.info2 / 100}`;
	} else if (handicapType === 64) {
		// l'handicap 3 e 4 vengono fusi in uno, che rappresenta la media tra i due invertita di segno
		const ahMediano = (-1)*(handicapTradotto.info3 + handicapTradotto.info4) / 2;
        handicapTradotto.info3 = `${ahMediano / 100}`;
        handicapTradotto.info3 = handicapTradotto.info3 > 0? "+" + handicapTradotto.info3 : handicapTradotto.info3;
		handicapTradotto.info4 = null;
		handicapTradotto.infoCalcolate = 3;
    } else if (handicapType === 70) {
        handicapTradotto.info1 = `${handicapTradotto.info1 / 10}`;
         handicapTradotto.info1 = handicapTradotto.info1 > 0? "+" + handicapTradotto.info1 : handicapTradotto.info1;
    } else if(handicapType === 71){
    	handicapTradotto.info1 = `${handicapTradotto.info4 / 10}`;
    } else if(handicapType === 72){
    	handicapTradotto.info1 = additionalData || handicapTradotto.info1;
    	handicapTradotto.info4 = `${handicapTradotto.info4 / 10}`;
    } else if (handicapType === 74){
		handicapTradotto.idAnagrafica = handicapTradotto.info1;
		handicapTradotto.idAnagrafica2 = handicapTradotto.info2;
		handicapTradotto.idAnagrafica3 = handicapTradotto.info3;
		if(additionalData){
			let splittingChar = '';
			if(additionalData.indexOf('$') > 0){
				splittingChar = '$';
			}
			else if(additionalData.indexOf(' - ') > 0){
				splittingChar = ' - ';
			}
			const values = additionalData.split(splittingChar);
			handicapTradotto.info1 = values[0];
			handicapTradotto.info2 = values[1];
			handicapTradotto.info3 = values[2];
		}
	} else if (handicapType === 67){
		handicapTradotto.idAnagrafica = handicapTradotto.info1;
		handicapTradotto.idAnagrafica2 = handicapTradotto.info2;
		handicapTradotto.idAnagrafica3 = handicapTradotto.info3;
		handicapTradotto.idAnagrafica4 = handicapTradotto.info4;
		handicapTradotto.idAnagrafica5 = handicapTradotto.info5;
		handicapTradotto.idAnagrafica6 = handicapTradotto.info6;
		if(additionalData){
			let splittingChar = '';
			if(additionalData.indexOf('$') > 0){
				splittingChar = '$';
			}
			else if(additionalData.indexOf(' - ') > 0){
				splittingChar = ' - ';
			}		
			const values = additionalData.split(splittingChar);
			handicapTradotto.info1 = values[0] === 'NOT_SPECIFIED'? "" : values[0];
			handicapTradotto.info2 = values[1] === 'NOT_SPECIFIED'? "" : values[1];
			handicapTradotto.info3 = values[2] === 'NOT_SPECIFIED'? "" : values[2];
			handicapTradotto.info4 = values[3] === 'NOT_SPECIFIED'? "" : values[3];
			handicapTradotto.info5 = values[4] === 'NOT_SPECIFIED'? "" : values[4];
			handicapTradotto.info6 = values[5] === 'NOT_SPECIFIED'? "" : values[5];
		}
	}
	else if (handicapType === 68){
		handicapTradotto.idAnagrafica = handicapTradotto.info1;
		handicapTradotto.idAnagrafica2 = handicapTradotto.info2;
		handicapTradotto.idAnagrafica3 = handicapTradotto.info3;
		handicapTradotto.idAnagrafica4 = handicapTradotto.info4;
		handicapTradotto.idAnagrafica5 = handicapTradotto.info5;
		if(additionalData){
			let splittingChar = '';
			if(additionalData.indexOf('$') > 0){
				splittingChar = '$';
			}
			else if(additionalData.indexOf(' - ') > 0){
				splittingChar = ' - ';
			}		
			const values = additionalData.split(splittingChar);
			handicapTradotto.info1 = values[0] === 'NOT_SPECIFIED'? "" : values[0];
			handicapTradotto.info2 = values[1] === 'NOT_SPECIFIED'? "" : values[1];
			handicapTradotto.info3 = values[2] === 'NOT_SPECIFIED'? "" : values[2];
			handicapTradotto.info4 = values[3] === 'NOT_SPECIFIED'? "" : values[3];
			handicapTradotto.info5 = values[4] === 'NOT_SPECIFIED'? "" : values[4];
		}
	} else if(handicapType === 78){
		handicapTradotto.idAnagrafica = handicapTradotto.info1;
		if(additionalData){
			handicapTradotto.info1 = additionalData;	
		}
		handicapTradotto.info3 = handicapTradotto.info3 != 0? handicapTradotto.info3 : "";
		handicapTradotto.info4 = handicapTradotto.info4 != 0? handicapTradotto.info4 : "";
		handicapTradotto.info5 = handicapTradotto.info5 != 0? handicapTradotto.info5 : "";
		handicapTradotto.info6 = handicapTradotto.info6 != 0? handicapTradotto.info6 : "";
		handicapTradotto.info7 = handicapTradotto.info7 != 0? handicapTradotto.info7 : "";
		handicapTradotto.info8 = handicapTradotto.info8 != 0? handicapTradotto.info8 : "";
	
	}  else if (handicapType === 80){
		handicapTradotto.info1 = handicapTradotto.info1 / 10;
		handicapTradotto.info3 = handicapTradotto.info3 / 10;
	}        
	return handicapTradotto;
}
